import React from 'react'
import { Checkbox } from '@mui/material'
import { Controller, Control } from 'react-hook-form'
import { TermsText } from './TermsText'

interface TermsCheckboxProps {
  control: Control<any>
  onChange: (checked: boolean) => void
  defaultValue?: boolean
}

export const TermsCheckbox = ({ control, onChange, defaultValue = false }: TermsCheckboxProps) => {
  return (
    <div>
      <Controller
        name="term"
        rules={{ required: '必須項目です' }}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange: fieldOnChange, value, ref, ...field } }) => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
              checked={value}
              onChange={(e, checked) => {
                fieldOnChange(e)
                onChange(checked)
              }}
              inputRef={ref}
              inputProps={{
                'aria-label': 'プライバシーポリシー、利用規約に同意して利用する',
              }}
              {...field}
            />
            <TermsText />
          </div>
        )}
      />
    </div>
  )
}
